/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import classNames from 'classnames';
import { ReactNode } from 'react';
import { useDrop } from 'react-dnd';
import { Identifiable } from '../../../../Utils/Interfaces/Identifiable';
import { Indexable } from '../../../../Utils/Interfaces/Indexable';
import { DroppableProps } from './DroppableProps';

export const Droppable = <U extends Identifiable, T extends Indexable<U>>({
  type,
  children,
  onHover,
  onDrop
}: DroppableProps<U, T> & { children?: ReactNode }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: type,
    hover: (item: T) => onHover?.(item),
    drop: (item: T) => onDrop?.(item),
    collect: (monitor) => ({
      isOver: !!monitor.isOver()
    })
  }));

  return (
    <div className={classNames('relative cursor-move')} ref={drop}>
      {isOver ? (
        <div className="absolute top-0 left-0 right-0 bottom-0 z-10 bg-yellow-500 bg-opacity-10 rounded-lg" />
      ) : undefined}
      {children}
    </div>
  );
};
